import { renderHTML } from "@agility/nextjs";

const AgilityRichText = ({
  html,
  prose = true,
  className = "",
  ...otherProps
}) => {
  // Convert empty <p></p> to <p><br/></p> before rendering
  const updatedHtml = html?.replace(/<p>\s*<\/p>/g, "<p><br/></p>");

  return (
    <div
      className={`${prose ? "tw-prose" : ""} ${className}`}
      dangerouslySetInnerHTML={renderHTML(updatedHtml)}
      {...otherProps}
    />
  );
};

export default AgilityRichText;
